"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const color_calculation_1 = require("@abrigo/color-calculation");
/** @description Calculates hex code of a variant of a base color, as described by the specially formatted cssVariableString parameter.
 *
 * @param {string} cssVariableString - String representing a base color or a variant of a base color. Format Details:
 *   - May include a "color-level" value ranging from 005 to 995 (i.e. --primary, --primary-500, --primary-140, --primary-740).
 *       500 is equivalent to the base color.
 *       005 is the color scaled almost to white.
 *       995 is the color scaled almost to black.
 *   - May include a "darken" adjustment, applied to the base color (i.e. --primary-darken-50)
 *       or to a "color-level variant" as described above (i.e. --primary-140-darken-50)
 *       with an adjustment value ranging from 5 representing 0.5% darkened (i.e. --primary-darken-5)
 *       to 995 representing 99.5% darkened (--primary-darken-995).
 *   - May include a "lighten" adjustment, which functions just like "darken".
 *
 * @return {string | undefined} Returns string hex code, or null if base color value cannot be found.
 */
function _calculateCssVariableValue(cssVariableString, bootstrapVariableOverrideValues) {
    // Strip '--' from start of cssVariableString.
    if (cssVariableString.startsWith("--")) {
        cssVariableString = cssVariableString.substring(2);
    }
    // Tokenize string. First token is base color, additional tokens represent modifications to make to base color.
    let cssVariableTokens = cssVariableString.split("-");
    let baseVariableString = cssVariableTokens[0];
    let colorModificationTokens = cssVariableTokens.slice(1);
    // Initialize with base value
    let baseColorHexCodeValue = _getBaseValue(baseVariableString, bootstrapVariableOverrideValues);
    // Ignore if color is not in overrideValues
    if (baseColorHexCodeValue === undefined) {
        return undefined;
    }
    return _getModifiedColor(baseColorHexCodeValue, colorModificationTokens);
}
exports.default = _calculateCssVariableValue;
function _getBaseValue(cssValueString, bootstrapVariableValues) {
    switch (cssValueString) {
        case "primary":
            return bootstrapVariableValues.primary;
        case "secondary":
            return bootstrapVariableValues.secondary;
        case "danger":
            return bootstrapVariableValues.danger;
    }
}
function _getModifiedColor(colorHexCodeValue, colorModificationTokens) {
    let index = 0;
    while (index < colorModificationTokens.length) {
        let token = colorModificationTokens[index];
        if (token === "lighten") {
            // Path consumes two tokens
            let lightenAmount = parseInt(colorModificationTokens[index + 1]) / 10;
            colorHexCodeValue = (0, color_calculation_1.lighten)(colorHexCodeValue, lightenAmount);
            index += 2;
        }
        else if (token === "darken") {
            // Path consumes two tokens
            let darkenAmount = parseInt(colorModificationTokens[index + 1]) / 10;
            colorHexCodeValue = (0, color_calculation_1.darken)(colorHexCodeValue, darkenAmount);
            index += 2;
        }
        else {
            // Path consumes one token
            let colorLevel = parseInt(colorModificationTokens[index]);
            colorHexCodeValue = (0, color_calculation_1.scaleLightnessToColorLevel)(colorHexCodeValue, colorLevel);
            index += 1;
        }
    }
    return colorHexCodeValue;
}
//# sourceMappingURL=CalculateCssVariableValue.js.map